import React from "react"
import { FormattedMessage } from "react-intl"

// for wasn`t need to replace extension on hooks files
export const useFormattedMessage = (id: string) => {
    return <FormattedMessage id={id} />
}